import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { animateScroll, Element } from 'react-scroll'; // Imports all Mixins

import { updateAppState } from '../../actions/applicationState';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import AsSeenOnTV from '../../components/AsSeenOnTV';
import Body from '../../components/Body';
import Charities from '../../components/Charities';
import Community from '../../components/Community';
import Footer from '../../components/Footer';
import HomepageFeaturedDogs from '../../components/HomepageFeaturedDogs';
import HomepageHero from '../../components/HomepageHero';
import HomepageInspiration from '../../components/HomepageInspiration';
import PromoSearch from '../../components/PromoSearch';
import SEO from '../../components/SEO';
import StructuredData, { organizationSchema, websiteSchema } from '../../components/StructuredData';

const scroll = animateScroll;

class Home extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.scrollDown.bind(this);
    this.state = {
      login_modal_open: false,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const backURL = searchParams.get('backURL');

    if (backURL === 'settings/account' && !this.props.user.isAuthenticated) {
      this.props.dispatch(
        updateAppState({
          login_modal_open: true,
        }),
      );
    }
    if (this.props.user.isAuthenticated && backURL) {
      this.props.history.push('/' + backURL);
    }
  }

  scrollDown() {
    scroll.scrollTo(window.innerHeight);
  }

  render() {
    return (
      <Body hasFooter>
        <SEO
          title="Find Local Dogs to Walk, Play With & Share"
          description={
            'Connect with dog owners in your area for dog walking, playdates, and ' +
            'companionship. Join The Dog Share Collective - where dog lovers meet dogs who need love.'
          }
          keywords="dog sharing, dog walking, dog sitting, pet sharing, dog borrowing, local dogs"
          url="https://www.thedogsharecollective.com/"
        />
        <StructuredData data={organizationSchema} />
        <StructuredData data={websiteSchema} />
        <HomepageHero
          user={this.props.user}
          scrollHandler={this.handleScroll}
          dispatch={this.props.dispatch}
        />
        <PromoSearch />
        <HomepageFeaturedDogs {...this.props} />
        <Element name="homepage-inspiration-1">
          <HomepageInspiration
            position={1}
            description="How it works"
            title="People who have dogs"
            text="
              Dog Owners profile their dog's doggie interests
              and companionship needs for trusted dog-lovers to review.
            "
          />
        </Element>
        <HomepageInspiration
          position={2}
          description=""
          title="Share their dogs"
          text="
            Dogs wait for compatible local dog-lovers to seek them out for dog walking,
            adventures or home hangs together, or to hook up with other local
            dogs for more dog-time.
          "
        />
        <HomepageInspiration
          position={3}
          description="With"
          title="People who can't have dogs"
          text="
            Dog Borrowers request matches and connect direct. Dog Owners start enriching
            their dog's life through dog sharing, enjoy peace of mind and save thousands.
            Dog Borrowers enjoy sharing their company with a dog.
          "
        />
        <Community dispatch={this.props.dispatch} />
        <Charities />
        <AsSeenOnTV />
        <Footer user={this.props.user} />
      </Body>
    );
  }
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  // appdata: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/views/Home/index.js